// Simple UK Detection and Redirect
(async function() {
  // Clear sessionStorage if not on .co.uk domain
  if (!window.location.hostname.includes('.co.uk')) {
    sessionStorage.clear();
  }
  
  // Skip if already checked
  if (sessionStorage.getItem('uk_checked')) return;
  
  // Skip if on UK domain
  if (window.location.hostname.includes('puregoatcompany.co.uk')) {
    sessionStorage.setItem('uk_checked', 'true');
    return;
  }
  
  // Check for UK indicators (fast, synchronous)
  const browserLang = navigator.language?.toLowerCase() || '';
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isUKBrowser = timezone === 'Europe/London' || 
                timezone === 'Europe/Belfast' || 
                timezone === 'Europe/Edinburgh';
  
  // If browser indicates UK, redirect immediately (no IP check needed)
  if (isUKBrowser) {
    console.log('UK detected via browser');
    sessionStorage.setItem('uk_checked', 'true');
    window.location.href = `https://puregoatcompany.co.uk${window.location.pathname}`;
    return;
  }
  
  // Only check IP if browser didn't indicate UK
  let isUKIP = false;
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    isUKIP = data.country_code === 'GB';
    console.log('IP Geolocation:', data.country_code);
  } catch (error) {
    console.log('IP check failed:', error);
  }
                
  if (isUKIP) {
    console.log('UK detected via IP');
    sessionStorage.setItem('uk_checked', 'true');
    window.location.href = `https://puregoatcompany.co.uk${window.location.pathname}`;
    return;
  }
  
  // Mark as checked for non-UK visitors
  sessionStorage.setItem('uk_checked', 'true');
})();